import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createAttendeePickupAssignment = (request) => {
    return vdkEmHappinessPortalApi.post(`/pickup-locations/${request.pickupLocationId}/attendee-assignments`, request);
};
const updateAttendeePickupAssignment = (request) => {
    return vdkEmHappinessPortalApi.put(`/attendee-assignments/${request.id}`, request);
};
const getAllAttendeePickupAssignments = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-all', request);
};
const getAssignedAttendeesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-all-assigned-attendee', request);
};
const getUnassignedAttendeesByPickupLocationId = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-all-unassigned-attendee', request);
};
const getAttendeePickupAssignmentById = (id) => {
    return vdkEmHappinessPortalApi.get(`/attendee-assignments/${id}`);
};
const deleteAttendeePickupAssignment = (id) => {
    return vdkEmHappinessPortalApi.delete(`/attendee-assignments/${id}`);
};
const unassignAttendeeFromVehicle = (attendeeIds) => {
    return vdkEmHappinessPortalApi.patch(`/attendee-assignments/unassign`, { attendeeIds });
};
const assignAttendeeToVehicle = (attendeeIds, vehicleId) => {
    return vdkEmHappinessPortalApi.patch(`/attendee-assignments/assign`, { attendeeIds, vehicleId });
};
const getAttendeesByVehicleId = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-all-by-vehicle', request);
};
const assignCoordinator = (request) => {
    return vdkEmHappinessPortalApi.patch('/attendee-assignments/assign-coordinator', { attendeeId: request.attendeeId, vehicleId: request.vehicleId });
};
const getUnassignedAttendeesByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-unassigned-attendee-by-event-Id', request);
};
const getAssignedAttendeesByEventId = (request) => {
    return vdkEmHappinessPortalApi.post('/attendee-assignments/get-assigned-attendees-by-event-id', request);
};
const reassignAttendeesToPickupLocation = (request) => {
    return vdkEmHappinessPortalApi.patch('/attendee-assignments/reassign-to-pickup-location', request);
};
const assignAttendeeCountToVehicle = (request) => {
    return vdkEmHappinessPortalApi.patch('/attendee-assignments/assign-count', request);
};
const attendeePickupAssignmentAPI = {
    createAttendeePickupAssignment,
    updateAttendeePickupAssignment,
    getAllAttendeePickupAssignments,
    getAssignedAttendeesByPickupLocationId,
    getUnassignedAttendeesByPickupLocationId,
    getAttendeePickupAssignmentById,
    deleteAttendeePickupAssignment,
    unassignAttendeeFromVehicle,
    assignAttendeeToVehicle,
    getAttendeesByVehicleId,
    assignCoordinator,
    getUnassignedAttendeesByEventId,
    getAssignedAttendeesByEventId,
    reassignAttendeesToPickupLocation,
    assignAttendeeCountToVehicle
};
export default attendeePickupAssignmentAPI;
